import React, { createContext, useContext, useEffect, useState } from 'react';
import useMediaQueryCalc from './useMediaQueryCalc';
// 'm' is used as the default as we want to optimise for mobile
export const MediaQueryContext = createContext({
    breakpoint: 's',
    isClientCalc: false
});
export const MediaQueryContextProvider = ({ children }) => {
    const breakpoint = useMediaQueryCalc();
    const [isClientCalc, setIsClientCalc] = useState(false);
    useEffect(() => {
        if (!isClientCalc) {
            setIsClientCalc(true);
        }
    }, [isClientCalc]);
    return (React.createElement(MediaQueryContext.Provider, { value: { breakpoint, isClientCalc } }, children));
};
const useBreakpointContext = () => useContext(MediaQueryContext);
export default useBreakpointContext;
//# sourceMappingURL=index.js.map